import React from "react";

const isHashTag = (word) => word.startsWith("#");

const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export const formatWord = (word) => {
  if (isValidHttpUrl(word)) {
    return (
      <React.Fragment key={word}>
        <button
          type="button"
          className="underline inline"
          key={word}
          onClick={() => {
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "open-external-link",
                  url: word,
                })
              );
            } else {
              window.open(word, "_blank");
            }
          }}
        >
          {word}
        </button>
      </React.Fragment>
    );
  }
  if (isHashTag(word)) {
    return (
      <React.Fragment key={word}>
        <b>{word}</b>{" "}
      </React.Fragment>
    );
  }
  return `${word} `;
};
